import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addImage } from '../../actions/ui';

import './blobImage.css';

export const BlobImage = props => {
    const { src, folder, localSrc, partnerId, ratioOverride, ...cleanProps } = props;

    const dispatch = useDispatch();
    const user = useSelector(state => state.user.user);
    const images = useSelector(state => state.ui.images);

    React.useEffect(() => {
        folder && src && dispatch(addImage(folder, src, partnerId));
    }, [folder, src, images, partnerId]);

    if (!user) return null;

    let ratio = ratioOverride || 66;
    let imageSrc = '';
    let defaultSrc = '/dist/img/placeholder.png';
    const settings = user.companySettings?.display ? user.companySettings.display : {};

    if (settings.logo) dispatch(addImage('logo', settings.logo, partnerId));
    if (settings.defaultBlogImage) dispatch(addImage('defaultBlogImage', settings.defaultBlogImage, partnerId));

    const getImageFromPotentials = (src, folder, images) => {
        if (src && images && images.length > 0) {
            const potentials = images.filter(i => i.file.indexOf(src) >= 0 && i.folder === folder);
            if (potentials.length > 0) {
                return potentials[0].src;
            }
        }

        return '';
    };

    switch (folder) {
        case 'logo':
        case 'richardson-thumb':
            ratio = 0;
            break;
        case 'avatar':
            ratio = 0;
            defaultSrc = '/dist/img/default-avatar.jpg';
            break;
        case 'badge_Icon':
            ratio = 0;
            defaultSrc = '/dist/img/default-badge.jpg';
            break;
        case 'question_Image':
            defaultSrc =
                getImageFromPotentials(settings.defaultBlogImage, 'defaultTestImage', images) || '/dist/img/test.jpg';
            break;
        case 'blog_Image':
            defaultSrc =
                getImageFromPotentials(settings.defaultBlogImage, 'defaultBlogImage', images) || '/dist/img/blog.png';
            break;
        default:
            break;
    }

    imageSrc = getImageFromPotentials(src, folder, images);

    if (localSrc) {
        imageSrc = localSrc;
    }

    imageSrc = imageSrc || defaultSrc;

    const image = <img {...cleanProps} alt="" loading="lazy" src={imageSrc} />;

    return ratio ? <div className={`blob-image-holder blob-image-holder-${ratio}`}>{image}</div> : image;
};

export default BlobImage;
